// @ts-nocheck
export const localStorageKeys = {
  CurrentTheme: 'current-theme',
  CurrentToken: 'current-token',
  IsPrivateReceiver: 'is-private-receiver',
  IsPrivateSender: 'is-private-sender',
  BridgeOriginChainName: 'bridge-origin-chain',
  BridgeDestinationChainName: 'bridge-destination-chain',
  SkipMantaWalletIntro: 'skip-manta-wallet-intro',
};
